import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { PERMISSIONS } from '@property/shared';
import { usePermissions } from '@/hooks/use-permissions';
import { AuditLog } from '@/features/audit/components/AuditLog';

export const Route = createFileRoute('/dashboard/audit/')({
  component: AuditPage,
});

function AuditPage() {
  const { can, isLoading } = usePermissions();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !can(PERMISSIONS.AUDIT_READ)) {
      navigate({ to: '/dashboard' });
    }
  }, [can, isLoading, navigate]);

  if (isLoading) return null;
  if (!can(PERMISSIONS.AUDIT_READ)) return null;

  return (
    <div className="p-6 space-y-6">
      <div>
        <h1 className="font-display text-2xl font-medium tracking-tight text-foreground">
          Audit Log
        </h1>
        <p className="text-muted-foreground text-sm mt-1">
          A record of all state-changing actions performed in the system.
        </p>
      </div>

      <AuditLog />
    </div>
  );
}
